// Customer-service contact shown in the payment UI (dates and amounts always
// come from props/API). Payments are arranged with customer service over
// WhatsApp; no bank details are shown in the app.
export const PAYMENT_WHATSAPP_NUMBER = '5491178257968';
export const PAYMENT_WHATSAPP_DISPLAY = '+54 9 11 7825 7968';

export function buildPaymentWhatsAppUrl(message) {
  return `https://wa.me/${PAYMENT_WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}

// Opens the customer-service chat with a fixed message (no amount or other data).
export const PAYMENT_WHATSAPP_URL = buildPaymentWhatsAppUrl('Hola, quiero realizar el pago de MercuryCom.');
